import { render, staticRenderFns } from "./fav.vue?vue&type=template&id=2cfa15d7&scoped=true&"
import script from "./fav.vue?vue&type=script&lang=js&"
export * from "./fav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfa15d7",
  null
  
)

export default component.exports